import {useContext} from "react";
import {ToastContext, ToastContextType} from "../context/ToastContext";

export function useToast() : ToastContextType{
    return useContext(ToastContext);
}